export default __webpack_public_path__ + "static/PerfectHeels5-1ddd8401af72ecabb2788aae2f2c7f1e.png";